import type { BillingIdentity } from "@/components/settings/BillingIdentityModal";

type IdentityFields = Pick<BillingIdentity, "billing_first_name" | "billing_last_name" | "billing_id_type" | "billing_id_number">;

export function maskIdNumber(idNumber: string): string {
  const compact = idNumber.trim();
  if (!compact) return "";
  const visible = compact.length > 6 ? 4 : 3;
  return `***${compact.slice(-Math.min(visible, Math.max(compact.length - 1, 1)))}`;
}

export function billingHolderName(identity: Pick<BillingIdentity, "billing_first_name" | "billing_last_name">): string {
  return [identity.billing_first_name, identity.billing_last_name].map((part) => part?.trim()).filter(Boolean).join(" ");
}

export function billingIdentityLabel(identity: IdentityFields): string {
  const holder = billingHolderName(identity) || "Sin nombre";
  return `${holder} · ${identity.billing_id_type} ${maskIdNumber(identity.billing_id_number)}`;
}

export const BILLING_IDENTITY_STAFF_WARNING =
  "Estos datos se usarán en todos los pagos de esta organización. No pongas tus datos personales salvo que tú seas quien paga.";
